import { createSelector } from 'reselect';

import type { ClientEsbConfig } from '@avalara/types/esb';
import type { State } from '@avalara/types/reducer-states';

export const getEsbConfig = (state: State): ClientEsbConfig | null =>
  state.esb.esbConfigMap?.[state.esb.esbPartner || ''] ?? null;

export const getEsbPartnerName: (_: State) => string = createSelector(
  [getEsbConfig],
  (esbConfig: ClientEsbConfig | null): string => esbConfig?.name ?? 'your platform',
);
